const translations = {
  pt: {
    loginInfo: 'Informação de Login',
    username: 'Nome de Usuário* (username)',
    password: 'Senha*',
    confirmPassword: 'Confirme sua Senha*',
    email: 'Email*',
    personalData: 'Dados Pessoais',
    fullName: 'Nome Completo*',
    cpf: 'CPF (opcional)',
    dateOfBirth: 'Data de Nascimento*',
    locationInfo: 'Informação de Localização',
    state: 'Estado*',
    selectState: 'Selecione seu estado',
    city: 'Cidade',
    selectCity: 'Selecione sua cidade',
    geoPermission: 'Permissão para coletar dados geográficos',
    occupationInfo: 'Informação sobre Ocupação',
    occupation: 'Ocupação*',
    selectOccupation: 'Selecione sua ocupação',
    student: 'Estudante',
    consultant: 'Consultor',
    researcher: 'Pesquisador',
    producer: 'Produtor',
    other: 'Outro',
    cropType: 'Tipo de Cultura*',
    plantedArea: 'Área Plantada de',
    plantedAreaPlaceholder: 'Área em hectares',
    plantingChallenges: 'Desafios de Plantio*',
    plantingChallengesPlaceholder: 'Discorra sobre os desafios de plantio que você enfrenta...',
    educationalInstitution: 'Instituição de Ensino*',
    isFarmerChild: 'Você é filho(a) de produtor rural?*',
    company: 'Empresa*',
    isInvolvedWithBiological: 'Você está envolvido com uso de biológicos?*',
    conductsCoffeeResearch: 'Você está envolvido com pesquisa em café?*',
    otherDescription: 'Descreva sua ocupação*',
    platformInterest: 'Interesses na Plataforma',
    platformInterestPlaceholder: 'Quais são seus interesses na plataforma?',
    registerButton: 'Registrar',
    createAccount: 'Criar conta',
    of: 'de',
    stepCounter: 'Passo',
    stepLabel1: 'Acesso',
    stepLabel2: 'Você',
    stepLabel3: 'Pronto',
    step1Title: 'Crie seu acesso',
    step1Subtitle: 'Comece a explorar o conhecimento em bioinsumos para o café.',
    step2Title: 'Sobre você',
    step2Subtitle: 'Isso personaliza o conteúdo para a sua realidade.',
    step3Title: 'Quase lá',
    step3Subtitle: 'Confira seus dados e crie sua conta.',
    continueBtn: 'Continuar',
    backBtn: 'Voltar',
    finishCreate: 'Criar minha conta',
    creating: 'Criando conta…',
    securityNote: 'Seus dados ficam protegidos e são usados só para personalizar seu conteúdo.',
    alreadyAccount: 'Já tem conta?',
    enterLink: 'Entrar',
    howWork: 'Como você atua no agro?',
    yourName: 'Seu nome',
    yourEmail: 'E-mail',
    createPassword: 'Crie uma senha',
    showPwd: 'Mostrar',
    hidePwd: 'Ocultar',
    cpfHelp: 'Opcional — usado só para personalizar seu conteúdo.',
    interestQuestion: 'O que você quer aprender por aqui? (opcional)',
    successMessage: 'Cadastro realizado com sucesso! Por favor, faça o login.',
    detailMessage: 'Entre com o seu e-mail e a senha que você acabou de cadastrar.',
    errorMessage: 'Falha no cadastro. O nome de usuário ou email já está em uso.',
    passwordErrorMinLength: 'Mínimo 6 caracteres (Obrigatório)',
    passwordErrorUpperCase: 'Pelo menos uma letra maiúscula',
    passwordErrorLowerCase: 'Pelo menos uma letra minúscula',
    passwordErrorNumber: 'Pelo menos um número',
    passwordErrorSpecialChar: 'Pelo menos um caractere especial',
    passwordMismatch: 'As senhas não coincidem',
    cpfInvalidFormat: 'Formato inválido (XXX.XXX.XXX-XX)',
    cpfInvalid: 'CPF inválido',
    missingFields: 'Falha. Campos obrigatórios faltando:',
    fieldNames: {
      cropType: 'Tipo de Cultura',
      areaplanted: 'Área Plantada',
      plantingChallengesDescription: 'Desafios de Plantio',
      company: 'Empresa',
      educationalInstitution: 'Instituição de Ensino',
      otherDescription: 'Descrição da Ocupação',
      isInvolvedWithBiological: 'Uso de Biológicos',
      conductsCoffeeResearch: 'Pesquisa em Café'
    },
    yes: 'Sim',
    no: 'Não',
    placeholderUsername: 'Digite seu nome de usuário',
    placeholderPassword: 'Digite sua senha',
    placeholderConfirmPassword: 'Confirme sua senha',
    placeholderEmail: 'exemplo@exemplo.com',
    placeholderFullName: 'Digite seu nome completo',
    placeholderCpf: 'XXX.XXX.XXX-XX',
    placeholderOtherDescription: 'Digite sua ocupação',
    placeholderCompany: 'Digite o nome da empresa',
    placeholderEducationalInstitution: 'Digite o nome da instituição de ensino',
    // Novas traduções para o modal de termos
    termsModalTitle: 'Termos de Uso e Política de Privacidade',
    termsContent: `
        <h4>TERMOS DE USO E POLÍTICA DE PRIVACIDADE</h4>

        <h5>1. DO OBJETO</h5>
        <p>O presente instrumento estabelece os Termos de Uso e a Política de Privacidade que regem a utilização da plataforma [Nome da Plataforma/Empresa], doravante denominada "Plataforma", por seus usuários, doravante denominados "Usuários". Ao acessar ou utilizar a Plataforma, o Usuário manifesta sua expressa e inequívoca concordância com as disposições aqui contidas.</p>

        <h5>2. DA COLETA E TRATAMENTO DE DADOS PESSOAIS</h5>
        <h6>2.1. Finalidade da Coleta</h6>
        <p>A Plataforma coletará e tratará dados pessoais dos Usuários com as seguintes finalidades:</p>
        <ul>
          <li>a) Fornecer e aprimorar os serviços e funcionalidades oferecidos pela Plataforma;</li>
          <li>b) Personalizar a experiência do Usuário, adaptando o conteúdo e as ofertas às suas preferências e necessidades;</li>
          <li>c) Comunicar informações relevantes sobre a Plataforma, produtos, serviços, atualizações e eventos;</li>
          <li>d) Realizar análises estatísticas e de mercado, visando o desenvolvimento de novos produtos e serviços;</li>
          <li>e) Cumprir obrigações legais, regulatórias e ordens judiciais, bem como exercer direitos em processos judiciais, administrativos ou arbitrais.</li>
        </ul>

        <h6>2.2. Dados Coletados</h6>
        <p>Os dados pessoais coletados poderão incluir, mas não se limitarão a: nome completo, CPF, data de nascimento, endereço de e-mail, informações de login (nome de usuário e senha), dados de localização geográfica, informações sobre ocupação (tipo de cultura, área plantada, desafios de plantio, envolvimento com biológicos, pesquisa em café, instituição de ensino, empresa, etc.), e interesses na Plataforma.</p>

        <h6>2.3. Coleta de Dados Geográficos (Obrigatória)</h6>
        <p>Para a plena funcionalidade da Plataforma e a oferta de serviços personalizados e regionalizados, a coleta de dados de localização geográfica é **obrigatória** para todos os Usuários. Ao aceitar estes Termos, o Usuário consente expressamente com a coleta e o tratamento de seus dados geográficos pela Plataforma, que serão utilizados para:</p>
        <ul>
          <li>a) Fornecer informações e recomendações específicas para a região do Usuário;</li>
          <li>b) Realizar análises estatísticas agregadas e anonimizadas sobre a distribuição geográfica dos Usuários e suas atividades;</li>
          <li>c) Aprimorar a precisão e relevância dos serviços oferecidos.</li>
        </ul>

        <h5>3. DA PROTEÇÃO DOS DADOS PESSOAIS</h5>
        <p>A Plataforma empregará as melhores práticas de segurança da informação, incluindo medidas técnicas e organizacionais adequadas, para proteger os dados pessoais dos Usuários contra acesso não autorizado, destruição, perda, alteração, comunicação ou difusão indevida ou ilícita. Não obstante, o Usuário reconhece que nenhuma transmissão de dados pela internet é totalmente segura, estando ciente dos riscos inerentes.</p>

        <h5>4. DOS DIREITOS DO TITULAR DOS DADOS</h5>
        <p>Em conformidade com a legislação aplicável, o Usuário, na qualidade de titular dos dados, possui os seguintes direitos:</p>
        <ul>
          <li>a) Confirmação da existência de tratamento;</li>
          <li>b) Acesso aos dados;</li>
          <li>c) Correção de dados incompletos, inexatos ou desatualizados;</li>
          <li>d) Anonimização, bloqueio ou eliminação de dados desnecessários, excessivos ou tratados em desconformidade com a lei;</li>
          <li>e) Portabilidade dos dados a outro fornecedor de serviço ou produto, mediante requisição expressa;</li>
          <li>f) Eliminação dos dados pessoais tratados com o consentimento do titular, exceto nas hipóteses previstas em lei;</li>
          <li>g) Informação das entidades públicas e privadas com as quais o controlador realizou uso compartilhado de dados;</li>
          <li>h) Informação sobre a possibilidade de não fornecer consentimento e sobre as consequências da negativa;</li>
          <li>i) Revogação do consentimento, a qualquer tempo.</li>
        </ul>
        <p>Para exercer quaisquer dos direitos acima, o Usuário deverá entrar em contato com a Plataforma através dos canais de atendimento disponibilizados.</p>

        <h5>5. DAS ALTERAÇÕES DESTES TERMOS</h5>
        <p>A Plataforma reserva-se o direito de modificar, a qualquer tempo, os presentes Termos de Uso e Política de Privacidade, mediante prévia comunicação aos Usuários. As alterações entrarão em vigor imediatamente após a publicação na Plataforma. A continuidade do uso da Plataforma após as modificações implicará na aceitação tácita dos novos termos.</p>

        <h5>6. DO FORO</h5>
        <p>Fica eleito o foro da comarca de [Cidade/Estado da Empresa] para dirimir quaisquer dúvidas ou litígios decorrentes do presente instrumento, com renúncia expressa a qualquer outro, por mais privilegiado que seja.</p>
      `,
    dataCollectionLabel: 'Autorizo a coleta e processamento dos meus dados pessoais, incluindo dados geográficos, conforme descrito nos termos acima.',
    termsAcceptanceLabel: 'Li, compreendi e concordo integralmente com os Termos de Uso e a Política de Privacidade.',
    acceptButton: 'Aceitar e Continuar',
    cancelButton: 'Cancelar',
    termsValidationError: 'Para prosseguir com o registro, é imprescindível que o Usuário aceite os Termos de Uso e Política de Privacidade, e autorize a coleta e o tratamento de seus dados pessoais, incluindo os dados geográficos, conforme as disposições contratuais.',
    emailInvalid: 'Email inválido',
    selectCropType: 'Selecione o tipo de cultura',
    occupationChangeWarning: 'Alterar a ocupação irá apagar todos os dados específicos da ocupação atual. Deseja continuar?',
    confirmChange: 'Confirmar Alteração',
    cancel: 'Cancelar',
    errorFetching: 'Erro ao buscar dados, por favor recarregue a página',
    passwordWeak: 'Fraca',
    passwordMedium: 'Média',
    passwordStrong: 'Forte',
    passwordStrengthLabel: 'Força da senha',
    passwordSuggestions: 'Para melhorar a segurança',
    usernameTooltipTitle: 'Informações sobre o Nome de Usuário',
    usernameTooltip: 'Seu nome de usuário será usado para fazer login. Escolha algo fácil de lembrar!',
    understood: 'Entendido',
  },
  en: {
    loginInfo: 'Login Information (username)',
    username: 'Username*',
    password: 'Password*',
    confirmPassword: 'Confirm Password*',
    email: 'Email*',
    personalData: 'Personal Information',
    fullName: 'Full Name*',
    cpf: 'CPF (optional)',
    dateOfBirth: 'Date of Birth*',
    locationInfo: 'Location Information',
    state: 'State*',
    selectState: 'Select your state',
    city: 'City',
    selectCity: 'Select your city',
    geoPermission: 'Permission to collect geographic data',
    occupationInfo: 'Occupation Information',
    occupation: 'Occupation*',
    selectOccupation: 'Select your occupation',
    student: 'Student',
    consultant: 'Consultant',
    researcher: 'Researcher',
    producer: 'Producer',
    other: 'Other',
    cropType: 'Crop Type*',
    plantedArea: 'Planted Area of',
    plantedAreaPlaceholder: 'Area in hectares',
    plantingChallenges: 'Planting Challenges*',
    plantingChallengesPlaceholder: 'Describe the planting challenges you face...',
    educationalInstitution: 'Educational Institution*',
    isFarmerChild: 'Are you a child of a farmer?*',
    company: 'Company*',
    isInvolvedWithBiological: 'Are you involved with biologicals?*',
    conductsCoffeeResearch: 'Are you involved with coffee research?*',
    otherDescription: 'Describe your occupation*',
    platformInterest: 'Platform Interests',
    platformInterestPlaceholder: 'What are your interests in the platform?',
    registerButton: 'Register',
    createAccount: 'Create account',
    of: 'of',
    stepCounter: 'Step',
    stepLabel1: 'Access',
    stepLabel2: 'About you',
    stepLabel3: 'Done',
    step1Title: 'Create your access',
    step1Subtitle: 'Start exploring knowledge on bioinputs for coffee.',
    step2Title: 'About you',
    step2Subtitle: 'This personalizes the content to your reality.',
    step3Title: 'Almost there',
    step3Subtitle: 'Review your details and create your account.',
    continueBtn: 'Continue',
    backBtn: 'Back',
    finishCreate: 'Create my account',
    creating: 'Creating account…',
    securityNote: 'Your data is protected and used only to personalize your content.',
    alreadyAccount: 'Already have an account?',
    enterLink: 'Sign in',
    howWork: 'How do you work in agriculture?',
    yourName: 'Your name',
    yourEmail: 'Email',
    createPassword: 'Create a password',
    showPwd: 'Show',
    hidePwd: 'Hide',
    cpfHelp: 'Optional — used only to personalize your content.',
    interestQuestion: 'What would you like to learn here? (optional)',
    successMessage: 'Registration successful! Please log in.',
    detailMessage: 'Sign in with the e-mail and password you just registered.',
    errorMessage: 'Registration failed. The username or email may already be in use.',
    passwordErrorMinLength: 'Minimum 6 characters (Required)',
    passwordErrorUpperCase: 'At least one uppercase letter',
    passwordErrorLowerCase: 'At least one lowercase letter',
    passwordErrorNumber: 'At least one number',
    passwordErrorSpecialChar: 'At least one special character',
    passwordMismatch: 'Passwords do not match',
    cpfInvalidFormat: 'Invalid format (XXX.XXX.XXX-XX)',
    cpfInvalid: 'Invalid CPF',
    missingFields: 'Failure. Required fields missing:',
    fieldNames: {
      cropType: 'Crop Type',
      areaplanted: 'Planted Area',
      plantingChallengesDescription: 'Planting Challenges',
      company: 'Company',
      educationalInstitution: 'Educational Institution',
      otherDescription: 'Occupation Description',
      isInvolvedWithBiological: 'Use of Biologicals',
      conductsCoffeeResearch: 'Coffee Research'
    },
    yes: 'Yes',
    no: 'No',
    placeholderUsername: 'Enter your username',
    placeholderPassword: 'Enter your password',
    placeholderConfirmPassword: 'Confirm your password',
    placeholderEmail: 'example@example.com',
    placeholderFullName: 'Enter your full name',
    placeholderCpf: 'XXX.XXX.XXX-XX',
    placeholderOtherDescription: 'Enter your occupation',
    placeholderCompany: 'Enter the company name',
    placeholderEducationalInstitution: 'Enter the name of the educational institution',
    // New translations for terms modal
    termsModalTitle: 'Terms of Use and Privacy Policy',
    termsContent: `
        <h4>TERMS OF USE AND PRIVACY POLICY</h4>

        <h5>1. OBJECT</h5>
        <p>This instrument establishes the Terms of Use and Privacy Policy that govern the use of the platform [Platform/Company Name], hereinafter referred to as "Platform", by its users, hereinafter referred to as "Users". By accessing or using the Platform, the User expresses their explicit and unequivocal agreement with the provisions contained herein.</p>

        <h5>2. COLLECTION AND PROCESSING OF PERSONAL DATA</h5>
        <h6>2.1. Purpose of Collection</h6>
        <p>The Platform will collect and process Users' personal data for the following purposes:</p>
        <ul>
          <li>a) Provide and improve the services and functionalities offered by the Platform;</li>
          <li>b) Personalize the User's experience, adapting content and offers to their preferences and needs;</li>
          <li>c) Communicate relevant information about the Platform, products, services, updates, and events;</li>
          <li>d) Conduct statistical and market analyses, aiming at the development of new products and services;</li>
          <li>e) Comply with legal, regulatory obligations and court orders, as well as exercise rights in judicial, administrative or arbitration proceedings.</li>
        </ul>

        <h6>2.2. Collected Data</h6>
        <p>The personal data collected may include, but will not be limited to: full name, CPF, date of birth, email address, login information (username and password), geographic location data, occupation information (crop type, planted area, planting challenges, involvement with biologicals, coffee research, educational institution, company, etc.), and platform interests.</p>

        <h6>2.3. Geographic Data Collection (Mandatory)</h6>
        <p>For the full functionality of the Platform and the offering of personalized and regionalized services, the collection of geographic location data is **mandatory** for all Users. By accepting these Terms, the User expressly consents to the collection and processing of their geographic data by the Platform, which will be used to:</p>
        <ul>
          <li>a) Provide specific information and recommendations for the User's region;</li>
          <li>b) Conduct aggregated and anonymized statistical analyses on the geographic distribution of Users and their activities;</li>
          <li>c) Improve the accuracy and relevance of the services offered.</li>
        </ul>

        <h5>3. PROTECTION OF PERSONAL DATA</h5>
        <p>The Platform will employ the best information security practices, including appropriate technical and organizational measures, to protect Users' personal data against unauthorized access, destruction, loss, alteration, undue or unlawful communication or dissemination. Nevertheless, the User acknowledges that no data transmission over the internet is entirely secure, being aware of the inherent risks.</p>

        <h5>4. RIGHTS OF THE DATA SUBJECT</h5>
        <p>In accordance with applicable law, the User, as the data subject, has the following rights:</p>
        <ul>
          <li>a) Confirmation of the existence of processing;</li>
          <li>b) Access to data;</li>
          <li>c) Correction of incomplete, inaccurate or outdated data;</li>
          <li>d) Anonymization, blocking or elimination of unnecessary, excessive or unlawfully processed data;</li>
          <li>e) Data portability to another service or product provider, upon express request;</li>
          <li>f) Elimination of personal data processed with the consent of the data subject, except in cases provided by law;</li>
          <li>g) Information on public and private entities with which the controller has shared data;</li>
          <li>h) Information on the possibility of not providing consent and on the consequences of refusal;</li>
          <li>i) Revocation of consent, at any time.</li>
        </ul>
        <p>To exercise any of the above rights, the User must contact the Platform through the available service channels.</p>

        <h5>5. CHANGES TO THESE TERMS</h5>
        <p>The Platform reserves the right to modify, at any time, these Terms of Use and Privacy Policy, by prior communication to Users. Changes will take effect immediately upon publication on the Platform. Continued use of the Platform after modifications will imply tacit acceptance of the new terms.</p>

        <h5>6. JURISDICTION</h5>
        <p>The jurisdiction of [City/State of Company] is elected to resolve any doubts or disputes arising from this instrument, with express waiver of any other, however privileged it may be.</p>
      `,
    dataCollectionLabel: 'I authorize the collection and processing of my personal data, including geographic data, as described in the terms above.',
    termsAcceptanceLabel: 'I have read, understood, and fully agree to the Terms of Use and Privacy Policy.', acceptButton: 'Accept and Continue',
    cancelButton: 'Cancel',
    termsValidationError: 'To proceed with registration, it is essential that the User accepts the Terms of Use and Privacy Policy, and authorizes the collection and processing of their personal data, including geographic data, in accordance with the contractual provisions.',
    emailInvalid: 'Invalid email',
    selectCropType: 'Select crop type',
    occupationChangeWarning: 'Changing the occupation will erase all specific data of the current occupation. Do you want to continue?',
    confirmChange: 'Confirm Change',
    cancel: 'Cancel',
    errorFetching: 'Error fetching data, please reload the page',
    passwordWeak: 'Weak',
    passwordMedium: 'Medium',
    passwordStrong: 'Strong',
    passwordStrengthLabel: 'Password strength',
    passwordSuggestions: 'To improve security',
    usernameTooltipTitle: 'Username Information',
    usernameTooltip: 'Your username will be used to log in. Choose something easy to remember!',
    understood: 'Understood',
  }
};

export default translations;